<template>
  <div class="add-car-warp">
    <div class="content">
      <div class="form">
        <van-cell-group>
          <van-field
            label="车牌号码"
            placeholder="请输入承保端车牌号码"
            label-class="form-item-label"
            v-model="carNo"
            :formatter="upperCase"
            maxlength="8"
            :disabled="whetherNew"
          >
            <!-- <template #button>
              <van-checkbox v-model="whetherNew" shape="square">新车</van-checkbox>
            </template> -->
          </van-field>
          <van-field
            label="车架号"
            placeholder="请输入车辆车架识别代码"
            label-class="form-item-label"
            v-model="vinNo"
            maxlength="17"
          />
          <van-field
            label="发动机号"
            placeholder="请输入车辆发动机号"
            label-class="form-item-label"
            v-model="engineNo"
            maxlength="25"
          />
        </van-cell-group>
        <van-uploader
          accept="image/*"
          :after-read="afterRead"
        >
          <div class="ocrName">输入太麻烦？试试OCR免输入></div>
        </van-uploader>
      </div>
      <div class="ocr">
        <img
          src="@/assets/img/license.png"
          class="complete"
        >
      </div>
      <div v-if="id">
        <div
          class="button"
          style="margin-top: 1.44rem"
        >
          <span
            :disabled="btnDisabled"
            class="submit"
            @click="submit"
          >保存修改</span>
        </div>
        <div class="delete-wrap">
          <span
            class="delete"
            @click="deleteCarClick"
          >删除车辆</span>
        </div>
      </div>
      <div
        class="button"
        v-if="!id"
      >
        <span
          :disabled="btnDisabled"
          class="submit"
          @click="submit"
        >提交</span>
      </div>
      <van-overlay
        :show="loading"
        class="ocr-loading"
      >
        <van-loading
          type="spinner"
          color="#c9c9c9"
          vertical
        >
          <span style="color: #c9c9c9">正在识别...</span>
        </van-loading>
      </van-overlay>
    </div>
  </div>
</template>

<script>
import { Field, Toast, Overlay, Loading, Dialog } from 'vant';
import {
  insertCar,
  ocrVehicleLicense,
  userCarDetail,
  userCarUntied,
  getCarOcr
} from '@/common/api.js';
import pattern from '@/utils/pattern.js';
import UploadHelper from '@/common/upload-helper.js';

export default {
  data() {
    return {
      carNo: '',
      vinNo: '',
      engineNo: '',
      rules: {
        carNo: [
          {
            required: true,
            message: '请输入车牌号'
          },
          {
            pattern: pattern.pattern.carNo,
            message: '请输入正确的车牌号'
          }
        ],
        vinNo: [
          {
            required: true,
            message: '请输入车架号'
          },
          {
            pattern: pattern.pattern.vinNo,
            message: '请输入正确的车架号'
          }
        ],
        engineNo: [
          {
            required: true,
            message: '请输入发动机号'
          },
          {
            min: 5,
            max: 25,
            message: '请输入正确的发动机号'
          },
          {
            pattern: pattern.pattern.engineNo,
            message: '请输入正确的发动机号'
          }
        ]
      },
      whetherNew: false, // 是否新车
      loading: false,
      id: ''
    };
  },

  computed: {
    btnDisabled() {
      return !(this.carNo && this.vinNo && this.engineNo);
    }
  },
  watch: {
    // 监听是否是新车
    whetherNew(newValue, oldValue) {
      this.whetherNew = newValue;
      if (newValue) {
        this.carNo = '*-*';
        this.rules.carNo = [
          {
            required: true,
            message: '请输入车牌号'
          }
        ];
      } else {
        this.carNo = '';
        this.rules.carNo = [
          {
            required: true,
            message: '请输入车牌号'
          },
          {
            pattern: pattern.pattern.carNo,
            message: '请输入正确的车牌号'
          }
        ];
      }
    }
  },

  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getCarInfo();
      document.getElementsByTagName('title')[0].innerText = '修改车辆';
    } else {
      document.getElementsByTagName('title')[0].innerText = '添加车辆';
    }
  },

  methods: {
    async getCarInfo() {
      try {
        await userCarDetail({
          id: this.id
        }).then((res) => {
          const item = res;
          console.log(item);
          this.carNo = item.carNo;
          this.vinNo = item.vinNo;
          this.engineNo = item.engineNo;
          if (item.carNo && item.carNo != '*-*') {
            this.whetherNew = false;
          } else {
            this.whetherNew = true;
          }
        });
      } catch (error) {}
    },

    goBack() {
      this.$router.go(-1);
    },

    upperCase(value) {
      return value.toUpperCase();
    },

    // 用户新增车辆接口
    async submit() {
      const vali = await pattern.$validate(this.rules, {
        carNo: this.carNo,
        vinNo: this.vinNo,
        engineNo: this.engineNo
      });

      if (vali.length > 0) {
        Toast(vali[0].message);
        return;
      }

      await insertCar(
        {
          id: this.id ? this.id : '',
          carNo: this.whetherNew ? '' : this.carNo,
          vinNo: this.vinNo,
          engineNo: this.engineNo
        },
        false
      ).then((res) => {
        if (this.id) {
          Toast('修改成功');
          this.$router.go(-1);
        } else {
          Toast('成功添加车辆');
          this.$router.push({
            name: 'interests',
            query: {
              source: 'addCar', // 新建车辆
              homePage: this.$route.query.homePage || ''
            }
          });
        }
      });
    },

    // OCR识别
    async afterRead(file) {
      this.loading = true;
      try {
        const res = await UploadHelper(
          file.file,
          'vasCommon/common/file/image/upload'
        );
        if (!res.picId) {
          this.$toast('图片上传失败');
          return;
        }
        const resp = await getCarOcr({ fileId: res.picId });
        this.loading = false;
        const item = resp;
        if (item && item.carNo) {
          this.engineNo = item.engineNo;
          if (!this.whetherNew) {
            this.carNo = item.carNo;
          }
          this.vinNo = item.vinNo;
        } else {
          Toast('识别失败');
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
        Toast('识别失败');
        this.loading = false;
      }
    },
    // 删除车辆
    deleteCarClick() {
      const that = this;
      Dialog.confirm({
        title: '提示',
        message: '确认删除当前车辆信息？'
      }).then(() => {
        that.deleteCar();
      });
    },
    async deleteCar() {
      try {
        await userCarUntied({
          id: this.id
        }).then((res) => {
          Toast('删除成功');
          this.$router.go(-1);
        });
      } catch (error) {
        console.log('后台数据有误');
      }
    }
  }
};
</script>

<style lang="scss">
.add-car-warp {
  width: 7.5rem;
  min-height: 100vh;
  font-family: PingFangSC-Regular;
  box-sizing: border-box;
  overflow: hidden;
  background: #f7f7f7;

  .content {
    width: 100%;
    height: 100%;

    .form {
      width: 100%;
      margin-top: 12px;
      display: flex;
      flex-direction: column;

      .ocrName {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #c0233f;
        text-align: right;
        margin-top: 10px;
        margin-right: 16px;
      }
    }

    .ocr {
      width: 100%;
      height: 4.8rem;
      background: #ffffff;
      margin-top: 32px;

      .complete {
        width: 6.06rem;
        height: 4rem;
        margin-left: 0.72rem;
        margin-top: 0.4rem;
      }
    }

    .button {
      width: 6.9rem;
      height: 48px;
      display: flex;
      flex-direction: column;
      margin-left: 0.3rem;
      margin-top: 2.21rem;
      margin-bottom: 0.2rem;

      .submit {
        border-radius: 4px;
        justify-content: center;
        line-height: 48px;
        height: 48px;
        background: #c0233f;
        font-size: 18px;
        color: #ffffff;
        text-align: center;
      }
    }

    .delete-wrap {
      display: flex;
      margin: 0.48rem 0;

      .delete {
        width: 100%;
        font-size: 16px;
        color: #c0233f;
        text-align: center;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.add-car-warp /deep/ .van-cell {
  padding-left: 15px;
}
.add-car-warp {
  .van-uploader {
    display: flex;
    justify-content: flex-end;
  }
}

.ocr-loading {
  .van-loading {
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
